var api = require("!../../../../node_modules/.pnpm/style-loader@1.3.0_webpack@5.105.2/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@5.105.2/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!../../../../node_modules/.pnpm/less-loader@7.3.0_less@3.13.1_webpack@5.105.2/node_modules/less-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!./company-select.less");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};